import  Default from "./default"
import devConfig from '@/devConfig'

let fhMenu = Default.menuData;
const userTypeName = {
    '0':'user',
    '1':'admin',
    '2':'super',
    '3':'debug'
}

// 现有版本列表 
const areaLits = {
    AIS:'AIS',
    TRUE:'TRUE',
    INTL:'INTL',
    TOT:'TOT',
    CLARO:'CLARO',
    CIK:'CIK'
}

function initActive(data) {
    data.forEach(element => {
        element.isActive = false;
        element.mobileActive = false;
        element.mobileColor = false;
        element.routeName = element.name.replace(/ /g,'_').toLowerCase();
        if(element.twoMenu) initActive(element.twoMenu);
        if(element.thrMenu) initActive(element.thrMenu);
    });  
}

function initMenu(menuData,Gconfig){
    if(typeof Gconfig.isWlBandSteering === 'undefined') return
    menuData.forEach((a) => {
        if(a.twoMenu)
        {
            a.twoMenu.forEach((b) => {
                if(b.componentName === "wanService"){    
                    //SR120-C 普通账户无wanService菜单
                    if(Gconfig.deviceName === "SR120-C" && Gconfig.userType == 0){
                        a.twoMenu.splice(0,1)
                    }
                }    

                if(b.thrMenu)
                {
                    b.thrMenu = b.thrMenu.filter((v) => {
                        // 目前只有需要根据双频合一开关 显示不同的无线菜单
                        if(typeof v.isBS !== 'undefined') return Gconfig.isWlBandSteering === v.isBS

                        // INTL 只有SR120-C 才有家长控制功能
                        if(v.componentName === 'parentalcontrol' ||v.componentName === 'wpsSetting' || v.componentName === 'wlGuest')
                        {
                            if(typeof Gconfig.deviceName != 'undefined'  && Gconfig.deviceName === 'SR120-C')
                                return true
                            else 
                                return false
                        }
                        
                        return true
                    })
                }
            })
        }
        
    })
    // 检查是否显示依赖USB的页面
    menuData.forEach((a) => {
        if(a.twoMenu)
        {
            a.twoMenu = a.twoMenu.filter((v) => {
                if(typeof v.isUSB !== 'undefined') return (Gconfig.userNum > 0) === v.isUSB
                    return true
            })
        }
        
    })
}

// initActive(fhMenu)
function init(){   
    const config = devConfig.getData()
    // TRUE 只有admin 用户菜单
    // 默认菜单路径 INTL/user
    let filename = userTypeName[config.userType] || 'user' 
    let path = areaLits[config.area] || 'INTL'
    fhMenu = require(`./${path}/${filename}`).default.menuData

    // 初始化菜单数据 删除不需要显示的菜单节点
    initMenu(fhMenu,config)

    /**初始化每个菜单的点击状态 */
    initActive(fhMenu)
}

function getMenu() {
    init()
    return fhMenu
}

export default {
    init,
    getMenu
}